<dx-form
  [formData]="formDataSig()"
  labelMode="floating"
  [readOnly]="readOnly"
  [validationGroup]="validationGroup"
  (onInitialized)="onInit($event)"
  [screenByWidth]="formWidth$ | async | formScreenByWidth: screenLimits"
>
  <!-- T-Shirt Block -->
  <dxi-item itemType="group" [visible]="tShirtBlockVisibleSig()" [colCountByScreen]="colCountByScreenSig()">
    <dxi-item [width]="200">
      <div *dxTemplate class="section-header">
        <div class="section-title">T-Shirt size</div>
        @if (!!tShirtNoteSig()) {
          <div class="section-note"  [class.section-note--padded]="sectionNotePaddingSig()">
            {{ tShirtNoteSig() }}</div>
        }

        @if (!!tShirtLabelSig()) {
          <div class="section-subtitle">{{ tShirtLabelSig() }}</div>
        }
      </div>
    </dxi-item>

    <dxi-item
      itemType="group"
      [colSpan]="layoutSig() === 'horizontal' ? 3 : 1"
      [colCountByScreen]="innerColCountByScreenSig()"
    >
      <!-- Category radio -->
      @if (tShirtCategoryVisibleSig()) {
        <dxi-item
          [dataField]="TShirtSizesKeys.tShirtCategory"
          [isRequired]="true"
          [editorType]="'dxRadioGroup'"
          [label]="{ visible: false }"
          [cssClass]="'flex-column mt-2'"
          [editorOptions]="{
            items: TShirtCategoryLookup,
            displayExpr: LookupKeys.description,
            valueExpr: LookupKeys.value,
            layout: 'horizontal',
          }"
        >
          <dxi-validation-rule type="required" [message]="Messages.REQUIRED_TEXT"></dxi-validation-rule>
        </dxi-item>
      }

      <!-- Size select -->
      <dxi-item [colSpan]="layoutSig() === 'horizontal' ? 2 : 1">
        <div *dxTemplate>
          <ag-shr-t-shirt-size-dropdown
            [value]="formDataSig()?.[TShirtSizesKeys.unisextShirtSize]"
            (valueChange)="formDataSig()[TShirtSizesKeys.unisextShirtSize] = $event"
            [category]="formDataSig()?.[TShirtSizesKeys.tShirtCategory]"
            [disabled]="!formDataSig()?.[TShirtSizesKeys.tShirtCategory]"
            [readOnly]="!formDataSig()?.[TShirtSizesKeys.tShirtCategory]"
            [isRequired]="true"
            [validationGroup]="validationGroup"
          ></ag-shr-t-shirt-size-dropdown>
        </div>
      </dxi-item>
    </dxi-item>
  </dxi-item>

  <!-- Shirt Block -->
  <dxi-item itemType="group" [visible]="shirtBlockVisibleSig()" [colCountByScreen]="colCountByScreenSig()">
    <dxi-item [width]="200">
      <div *dxTemplate class="section-header">
        <div class="section-title mt-2">Shirt size</div>

        @if (shirtLabelSig()) {
          <div class="section-subtitle">{{ shirtLabelSig() }}</div>
        }
      </div>
    </dxi-item>

    <dxi-item
      itemType="group"
      [colSpan]="layoutSig() === 'horizontal' ? 3 : 1"
      [colCountByScreen]="innerColCountByScreenSig()"
    >
      <dxi-item
        [isRequired]="true"
        [label]="{ visible: false }"
        [dataField]="TShirtSizesKeys.shirtCategory"
        [editorType]="'dxRadioGroup'"
        [cssClass]="'flex-column mt-2'"
        [editorOptions]="{
          items: ShirtCategoryLookup,
          displayExpr: LookupKeys.description,
          valueExpr: LookupKeys.value,
          layout: 'horizontal',
        }"
      >
        <dxi-validation-rule type="required" [message]="Messages.REQUIRED_TEXT"></dxi-validation-rule>
      </dxi-item>

      <dxi-item [colSpan]="layoutSig() === 'horizontal' ? 2 : 1">
        <div *dxTemplate>
          <ag-shr-t-shirt-size-dropdown
            [value]="formDataSig()?.[TShirtSizesKeys.genderTShirtSize]"
            (valueChange)="formDataSig()[TShirtSizesKeys.genderTShirtSize] = $event"
            [category]="formDataSig()?.[TShirtSizesKeys.shirtCategory]"
            [disabled]="!formDataSig()?.[TShirtSizesKeys.shirtCategory]"
            [readOnly]="!formDataSig()?.[TShirtSizesKeys.shirtCategory]"
            [isRequired]="true"
            [validationGroup]="validationGroup"
          ></ag-shr-t-shirt-size-dropdown>
        </div>
      </dxi-item>
    </dxi-item>
  </dxi-item>
</dx-form>
